import { Box, styled, Typography } from '@mui/material';
import { Row } from 'further-ui/components/Layout';
import api from 'lib/trpcClient';

import TaxDeclarationsDetails from '../TaxDeclarationsDetails';
import PreviousResultsContainer from './PreviousResultsContainer';

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, theme.spacingSizes.sm),
}));

const ExpiredAt = styled(Typography)({
  flexShrink: 0,
});

type Props = {
  vehicleId: string;
  vehicleApplicationId: string;
};

const PreviousTaxDeclarations: React.FC<Props> = ({
  vehicleId,
  vehicleApplicationId,
}) => {
  const [expiredTaxDetails] =
    api.investorTaxDetails.listExpiredTaxDetails.useSuspenseQuery({
      vehicleId,
      vehicleApplicationId,
    });

  if (!expiredTaxDetails.length) {
    return null;
  }

  return (
    <PreviousResultsContainer>
      {expiredTaxDetails.map((taxDetails) => (
        <Container key={taxDetails.id}>
          <Row fullWidth justify="space-between">
            <TaxDeclarationsDetails taxDetails={taxDetails} />
            <ExpiredAt variant="body2" align="right">
              Expired on {taxDetails.expiredAt?.toReadableWithTime()}
            </ExpiredAt>
          </Row>
        </Container>
      ))}
    </PreviousResultsContainer>
  );
};

export default PreviousTaxDeclarations;
